import { createApiClient } from '../keycloak-admin/api-client';
import { TAK_BASE, TAK_ENDPOINTS } from './endpoints';
import type { TakContact, TakGroup, TakServerInfo, TakMission } from './types';

function takClient(token: string) {
  return createApiClient(TAK_BASE, token);
}

export async function fetchContacts(token: string): Promise<TakContact[]> {
  const client = takClient(token);
  const data = await client.get<TakContact[] | { data: TakContact[] }>(TAK_ENDPOINTS.CONTACTS);
  return Array.isArray(data) ? data : (data?.data ?? []);
}

export async function fetchGroups(token: string): Promise<TakGroup[]> {
  const client = takClient(token);
  const data = await client.get<TakGroup[] | { data: TakGroup[] }>(TAK_ENDPOINTS.GROUPS);
  return Array.isArray(data) ? data : (data?.data ?? []);
}

export async function fetchServerInfo(token: string): Promise<TakServerInfo> {
  const client = takClient(token);
  const data = await client.get<TakServerInfo | { version: string }>(TAK_ENDPOINTS.VERSION);
  return {
    version: (data as TakServerInfo).version ?? 'unknown',
    apiVersion: (data as TakServerInfo).apiVersion,
    hostname: (data as TakServerInfo).hostname,
  };
}

export async function fetchMissions(token: string): Promise<TakMission[]> {
  const client = takClient(token);
  const data = await client.get<TakMission[] | { data: TakMission[] }>(TAK_ENDPOINTS.MISSIONS);
  return Array.isArray(data) ? data : (data?.data ?? []);
}
